import React, { useState, useEffect, useMemo } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, Alert } from 'reactstrap';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getApplicationPhaseList, getEnvironmentalComponentList, getEvidenceTypeList, getImpactList, getNormativeList, getPeriodicityList, getProbabilityList, getRelevantAspectList, getSupervisoryEntityList } from '../../../../helpers/normative/backend_helper';
import { getManagementList, getProductiveCycleStageList } from '../../../../helpers/establishment/backend_helper';
import { addNewActivityTemplateItem, addNewObligation, getActivityTemplateItemList, getArticleList, updateActivityTemplate, updateActivityTemplateItem, updateObligation } from '../../../../slices/thunks';
import OSelect from '../../../../Components/OElements/OSelect';
import { setRequireCloseModal as setRequireCloseModalObligation } from '../../../../slices/obligation/reducer';
import { setRequireCloseModal as setRequireCloseModalActivityTemplateItem } from '../../../../slices/activity/reducer';
import { getActivityGroupList, getActivityPriorityList, getActivityStatusList, getActivityTypeList } from '../../../../helpers/activity/backend_helper';
import useActivityTemplate from '../../../../Components/Hooks/useActivityTemplateHooks';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import FetchArticleModal from '../Add_Edit/FetchArticleModal';
import OHr from '../../../../Components/OElements/OHr';

const ObligationForm = ({ dataObligation, isEdit, handleToggleModal, isOpen, activeTab, toggleTab }) => {
    const dispatch = useDispatch();

    const { itemActivityTemplateDetail } = useActivityTemplate('PO');
    const [dataActivityTemplateItem, setDataActivityTemplateItem] = useState(null);
    const [dataList, setDataList] = useState([]);
    const handleArticleSelected = (selectedData) => {
        setDataList(selectedData);
    };

    const [selectedImpact, handleImpactSelected] = useState(null);
    const [selectedProbability, handleProbabilitySelected] = useState(null);
    const [selectedPeriodicity, handlePeriodicitySelected] = useState(null);
    const [selectedApplicationPhase, handleApplicationPhaseSelected] = useState(null);
    const [selectedProductiveCycleStage, handleProductiveCycleStageSelected] = useState(null);
    const [selectedRelevantAspect, handleRelevantAspectSelected] = useState(null);
    const [selectedEnvironmentalComponent, handleEnvironmentalComponentSelected] = useState(null);
    const [selectedEvidenceType, handleEvidenceTypeSelected] = useState(null);
    const [selectedArea, handleAreaSelected] = useState(null);
    const [selectedEntityReport, handleEntityReportSelected] = useState(null);
    const [selectedActivityGroup, handleActivityGroupSelected] = useState(null);
    const [selectedActivityStatus, handleActivityStatusSelected] = useState(null);
    const [selectedActivityPriority, handleActivityPrioritySelected] = useState(null);
    const [selectedActivityType, handleActivityTypeSelected] = useState(null);


    const [view_days, setViewDays] = useState(false);

    const selectorObligation = createSelector(
        state => state.Obligations,
        obligation => ({
            isAddingObligation: obligation.isAdding,
            isAddedObligation: obligation.isAdded,
            isUpdatingObligation: obligation.isUpdating,
            isUpdatedObligation: obligation.isUpdated,
            isLoadingListObligation: obligation.isLoadingList,
            requireCloseModalObligation: obligation.requireCloseModal,
        })
    );

    const {
        isAddingObligation,
        isUpdatingObligation,
        requireCloseModalObligation
    } = useSelector(selectorObligation);

    const selectorActivityTemplateItem = createSelector(
        state => state.Activities,
        activitie => ({
            isAddingActivityTemplateItem: activitie.isAdding,
            isAddedActivityTemplateItem: activitie.isAdded,
            isUpdatingActivityTemplateItem: activitie.isUpdating,
            isUpdatedActivityTemplateItem: activitie.isUpdated,
            isLoadingListActivityTemplateItem: activitie.isLoadingList,
            requireCloseModalActivityTemplateItem: activitie.requireCloseModal,
        })
    );

    const {
        isAddingActivityTemplateItem,
        isUpdatingActivityTemplateItem,
        requireCloseModalActivityTemplateItem
    } = useSelector(selectorActivityTemplateItem);

    // Función para extraer y guardar los _id
    const extractIds = (list) => {
        const ids = list.map(item => item._id);
        return ids;
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name_obligation: dataObligation.name || '',
            summary: dataObligation.summary || '',
            observation: dataObligation.observation || '',
            disabled: dataObligation.disabled || false,
            impact_id: '',
            probability_id: '',
            activity_periodicity_id: '',
            application_phase_ids: [],
            relevant_aspect_id: '',
            environmental_component_id: '',
            evidence_type_id: '',
            management_ids: [],
            supervisory_entity_ids: [],
            productive_cycle_stage_ids: [],
            name_activity: '',
            activity_group_id: '',
            activity_status_id: '',
            activity_priority_id: '',
            activity_type_id: '',
        },
        validationSchema: Yup.object({
            name_obligation: Yup
                .string()
                .required('Campo requerido')
            ,
            impact_id: Yup
                .string()
                .required('Campo requerido')
            ,
            probability_id: Yup
                .string()
                .required('Campo requerido')
            ,
            activity_periodicity_id: Yup
                .string()
                .required('Campo requerido')
            ,
            application_phase_ids: Yup
                .array()
                .of(Yup.string())
            ,
            relevant_aspect_id: Yup
                .string()
                .nullable()
            ,
            environmental_component_id: Yup
                .string()
                .nullable()
            ,
            evidence_type_id: Yup
                .string()
                .required('Campo requerido')
            ,
            management_ids: Yup
                .array()
                .of(Yup.string())
            ,
            supervisory_entity_ids: Yup
                .array()
                .of(Yup.string())
            ,
            productive_cycle_stage_ids: Yup
                .array()
                .of(Yup.string())
            ,
            name_activity: Yup
                .string()
                .required('Campo requerido')
            ,
            activity_group_id: Yup
                .string()
                .nullable()
            ,
            activity_status_id: Yup
                .string()
                .nullable()
            ,
            activity_priority_id: Yup
                .string()
                .nullable()
            ,
            activity_type_id: Yup
                .string()
                .nullable()
        }),
        onSubmit: async (values) => {
            const payloadObligation = {
                name: values.name_obligation,
                impact_id: values.impact_id,
                probability_id: values.probability_id,
                relevant_aspect_id: values.relevant_aspect_id,
                environmental_component_id: values.environmental_component_id,
                application_phase_ids: values.application_phase_ids,
                observation: values.observation,
                article: extractIds(dataList)
            };
            const payloadActivity = {
                name: values.name_activity,
                summary: values.summary,
                days_duration: view_days ? values.days_duration : 0,
                type_days: values.type_days,
                activity_periodicity_id: values.activity_periodicity_id,
                evidence_type_id: values.evidence_type_id,
                management_ids: values.management_ids,
                supervisory_entity_ids: values.supervisory_entity_ids,
                productive_cycle_stage_ids: values.productive_cycle_stage_ids,
                activity_template_id: itemActivityTemplateDetail._id,
                activity_group_id: values.activity_group_id,
                activity_status_id: values.activity_status_id,
                activity_priority_id: values.activity_priority_id,
                activity_type_id: values.activity_type_id,
            };

            if (isEdit) {
                await dispatch(
                    updateObligation({
                        ...payloadObligation,
                        _id: dataObligation._id
                    })
                );
                await dispatch(
                    updateActivityTemplateItem({
                        ...dataActivityTemplateItem,
                        ...payloadActivity
                    })
                );
            } else {
                let obligation = await dispatch(
                    addNewObligation(payloadObligation)
                );
                payloadActivity['obligation_id'] = obligation.payload._id;
                await dispatch(
                    addNewActivityTemplateItem(payloadActivity)
                );
            }
        },
    });


    useEffect(() => {
        if (
            isOpen &&
            requireCloseModalObligation &&
            requireCloseModalActivityTemplateItem
        ) {
            handleToggleModal();
            dispatch(setRequireCloseModalObligation(false));
            dispatch(setRequireCloseModalActivityTemplateItem(false));
        }
    }, [requireCloseModalObligation, requireCloseModalActivityTemplateItem]);


    useEffect(() => {
        setViewDays(selectedPeriodicity?.code === 'P');
    }, [selectedPeriodicity]);

    const [typeDaysChecked, setTypeDaysChecked] = useState(false);
    const handleTypeDaysCheckboxChange = () => {
        setTypeDaysChecked(!typeDaysChecked);
    };

    // Delete Data
    const handleClickDelete = article => {
        setDataArticle(article);
        setModalDelete(true);
    };

    // Update Data
    const handleClickEdit = article => {
        setDataArticle(article);
        handleToggleModalArticle();
    };

    const [articleModal, setArticleModal] = useState(false);
    function handleClickFetchArticle() {
        setArticleModal(!articleModal);
    }

    async function getActivityTemplateItemObligation(obligationId) {
        try {
            const response = await dispatch(getActivityTemplateItemList({ obligation_id: obligationId })).unwrap();
            if (response.length) {
                setDataActivityTemplateItem(response[0]);
            }
        } catch (err) {
            console.error('Error al subir archivo:', err);
        };
    }

    useEffect(() => {
        if (isEdit && dataObligation) {
            getActivityTemplateItemObligation(dataObligation._id);
        }
    }, [isEdit])

    useEffect(() => {
        if (dataActivityTemplateItem) {
            validation.setFieldValue('name_activity', dataActivityTemplateItem.name);
            validation.setFieldValue('summary', dataActivityTemplateItem.summary);
            // validation.setFieldValue('days_duration', dataActivityTemplateItem.days_duration);
            // validation.setFieldValue('type_days', dataActivityTemplateItem.type_days);
            // validation.setFieldValue('activity_periodicity_id', dataActivityTemplateItem.activity_periodicity_id);
            // validation.setFieldValue('evidence_type_id', dataActivityTemplateItem.evidence_type_id);
            // validation.setFieldValue('management_ids', dataActivityTemplateItem.management_ids);
            // validation.setFieldValue('supervisory_entity_ids', dataActivityTemplateItem.supervisory_entity_ids);
            // validation.setFieldValue('productive_cycle_stage_ids', dataActivityTemplateItem.productive_cycle_stage_ids);
            // validation.setFieldValue('activity_template_id', dataActivityTemplateItem.activity_template_id);
            // validation.setFieldValue('activity_group_id', dataActivityTemplateItem.activity_group_id);
            // validation.setFieldValue('activity_status_id', dataActivityTemplateItem.activity_status_id);
            // validation.setFieldValue('activity_priority_id', dataActivityTemplateItem.activity_priority_id);
            // validation.setFieldValue('activity_type_id', dataActivityTemplateItem.activity_type_id);
        }
    }, [dataActivityTemplateItem])

    const columns = useMemo(
        () => [
            {
                header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
                accessorKey: 'article_form',
                columnDefType: 'display',
                size: 'auto',
                Cell: cellProps => {
                    return (
                        <React.Fragment>
                            <div className='d-flex'>
                                <div className='flex-shrink-0'>
                                    <ul className='list-inline mb-0'>
                                        <li className='list-inline-item'>
                                            <Link
                                                to='#'
                                                className='remove-item-btn'
                                                onClick={() => {
                                                    const articleData =
                                                        cellProps.row.original;
                                                    handleClickDelete(articleData);
                                                }}
                                            >
                                                <i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </React.Fragment>
                    );
                },
            },
            { header: 'Normativa', accessorKey: 'normative.name', size: 'auto' },
            { header: 'Artículo', accessorKey: 'article', size: 'auto', },
            {
                header: 'Usuario Creación',
                accessorFn: (
                    row => (
                        row?.user_info?.length
                            ? row.user_info[0].full_name.toString()
                            : ''
                    )
                ),
                size: 'auto',
                Cell: ({ row }) => {
                    return (
                        row?.original?.user_info?.length
                            ? row.original.user_info[0].full_name.toString()
                            : ''
                    );
                },
            },
            {
                header: 'Fecha de Creación',
                accessorKey: 'creation_date',
                dataType: 'datetime'
            },
            {
                header: 'Desactivado',
                accessorKey: 'disable',
                size: 'auto', visible: false,
                Cell: ({ row }) => {
                    return (
                        <input
                            className='form-check-input'
                            role='switch'
                            type='checkbox'
                            id='disabled'
                            name='disabled'
                            disabled
                            checked={row.original.disable}
                        />
                    );
                },
            },
        ],
        [handleClickEdit]
    );


    const renderFormInputsInfo = () => (
        <>
            <Col lg={12}>
                <Label for='name_obligation' className='form-label'>
                    Nombre de la obligación
                </Label>
                <Input
                    id='name_obligation'
                    name='name_obligation'
                    className='form-control'
                    placeholder='Ingrese un número'
                    type='text'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name_obligation || ''}
                    invalid={validation.touched.name_obligation && validation.errors.name_obligation ? true : false}
                />
                {validation.touched.name_obligation && validation.errors.name_obligation && (
                    <FormFeedback type='invalid'>
                        {validation.errors.name_obligation}
                    </FormFeedback>
                )}
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`impact_id`}
                    label='Impacto'
                    id='impact_id'
                    name='impact_id'
                    value={dataObligation?.impact?._id || ''}
                    onSelect={handleImpactSelected}
                    requestApi={() => getImpactList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`probability_id`}
                    label='Probabilidad'
                    id='probability_id'
                    name='probability_id'
                    value={dataObligation?.probability?._id || ''}
                    onSelect={handleProbabilitySelected}
                    requestApi={() => getProbabilityList()}
                    validation={validation}
                />
            </Col>

            <Col lg={3}>
                <OSelect
                    key={`relevant_aspect_id`}
                    label='Aspecto Relevante'
                    id='relevant_aspect_id'
                    name='relevant_aspect_id'
                    value={dataObligation?.relevant_aspect?._id || ''}
                    onSelect={handleRelevantAspectSelected}
                    requestApi={() => getRelevantAspectList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key='environmental_component_id'
                    label='Componente Ambiental'
                    id='environmental_component_id'
                    name='environmental_component_id'
                    value={dataObligation?.environmental_component?._id || ''}
                    onSelect={handleEnvironmentalComponentSelected}
                    requestApi={() => getEnvironmentalComponentList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key='application_phase_ids'
                    label='Fase de Aplicación'
                    id='application_phase_ids'
                    name='application_phase_ids'
                    value={dataObligation?.application_phase_ids || ''}
                    onSelect={handleApplicationPhaseSelected}
                    requestApi={() => getApplicationPhaseList()}
                    validation={validation}
                    isMulti={true}
                />
            </Col>
            <Col lg={9}>
                <Label for='observation' className='form-label'>
                    Observación
                </Label>
                <Input
                    name='observation'
                    id='observation'
                    className='form-control'
                    placeholder='Ingrese una descripción'
                    type='textarea'
                    rows={5}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.observation || ''}
                    invalid={validation.touched.observation && validation.errors.observation ? true : false}
                />
                {validation.touched.observation && validation.errors.observation && (
                    <FormFeedback type='invalid'>
                        {validation.errors.observation}
                    </FormFeedback>
                )}
            </Col>

            <OHr text={'Artículos de la obligación'} />

            <Col lg={12} className='d-flex justify-content-end'>
                <button type='button' onClick={handleClickFetchArticle} className='btn btn-label btn-primary' id='add-btn-article'><i className="ri-search-line label-icon"></i> Buscar Artículos</button>
            </Col>
            <Col lg={12}>
                <ODataGrid columns={columns} data={dataList || []} />
            </Col>
        </>
    );

    const renderFormInputsControl = () => (
        <>
            <Col lg={6}>
                <Label for='name_activity' className='form-label'>
                    Nombre de la Actividad
                </Label>
                <Input
                    name='name_activity'
                    id='name_activity'
                    className='form-control'
                    placeholder='Ingrese un nombre'
                    type='text'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name_activity || ''}
                    invalid={validation.touched.name_activity && validation.errors.name_activity ? true : false}
                />
                {validation.touched.name_activity && validation.errors.name_activity ? (
                    <FormFeedback type='invalid'>
                        {validation.errors.name_activity}
                    </FormFeedback>
                ) : null}
            </Col>
            <Col lg={6}>
                <Label for='summary' className='form-label'>
                    Descripción
                </Label>
                <Input
                    name='summary'
                    id='summary'
                    className='form-control'
                    placeholder='Ingrese una descripción'
                    type='textarea'
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.summary || ''}
                    invalid={validation.touched.summary && validation.errors.summary ? true : false}
                />
                {validation.touched.summary && validation.errors.summary && (
                    <FormFeedback type='invalid'>
                        {validation.errors.summary}
                    </FormFeedback>
                )}
            </Col>

            <OHr text={'Características de la actividad de control'} />

            <Col lg={3}>
                <OSelect
                    key={`activity_type_id${dataActivityTemplateItem?.activity_type_id || ''}`}
                    label='Tipo'
                    id='activity_type_id'
                    name='activity_type_id'
                    value={dataActivityTemplateItem?.activity_type_id || ''}
                    onSelect={handleActivityTypeSelected}
                    requestApi={() => getActivityTypeList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`activity_group_id${dataActivityTemplateItem?.activity_group_id || ''}`}
                    label='Grupo'
                    id='activity_group_id'
                    name='activity_group_id'
                    value={dataActivityTemplateItem?.activity_group_id || ''}
                    onSelect={handleActivityGroupSelected}
                    requestApi={() => getActivityGroupList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`activity_priority_id${dataActivityTemplateItem?.activity_priority_id || ''}`}
                    label='Prioridad'
                    id='activity_priority_id'
                    name='activity_priority_id'
                    value={dataActivityTemplateItem?.activity_priority_id || ''}
                    onSelect={handleActivityPrioritySelected}
                    requestApi={() => getActivityPriorityList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`activity_periodicity_id${dataActivityTemplateItem?.periodicity_id || ''}`}
                    label='Periodicidad'
                    id='activity_periodicity_id'
                    name='activity_periodicity_id'
                    value={dataActivityTemplateItem?.periodicity_id || ''}
                    onSelect={handlePeriodicitySelected}
                    requestApi={() => getPeriodicityList()}
                    validation={validation}
                />
            </Col>
            {view_days && (
                <Col lg={3}>
                    <Label for='days_duration' className='form-label'>
                        Total de Días -
                        <div className="form-check form-switch form-switch-right">
                            <span style={{ margin: '0px 5px' }}>
                                {typeDaysChecked ? ' Habiles ' : ' Corridos '}
                            </span>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="type_days"
                                checked={typeDaysChecked}
                                onChange={handleTypeDaysCheckboxChange}
                            />
                        </div>
                    </Label>
                    <Input
                        name='days_duration'
                        id='days_duration'
                        className='form-control'
                        placeholder='Ingrese los días'
                        type='text'
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.days_duration || ''}
                        invalid={validation.touched.days_duration && validation.errors.days_duration ? true : false}
                    />
                    {validation.touched.days_duration && validation.errors.days_duration ? (
                        <FormFeedback type='invalid'>
                            {validation.errors.days_duration}
                        </FormFeedback>
                    ) : null}
                </Col>
            )}
            <Col lg={3}>
                <OSelect
                    key={`${dataActivityTemplateItem?.productive_cycle_stage_ids || ''}`}
                    label='Etapa Ciclo Productivo'
                    id='productive_cycle_stage_ids'
                    name='productive_cycle_stage_ids'
                    value={dataActivityTemplateItem?.productive_cycle_stage_ids || []}
                    onSelect={handleProductiveCycleStageSelected}
                    requestApi={() => getProductiveCycleStageList()}
                    validation={validation}
                    isMulti
                />
            </Col>

            <OHr text={'Responsabilidad y reportabilidad'} />

            <Col lg={3}>
                <OSelect
                    key={`${dataActivityTemplateItem?.management_ids || ''}`}
                    label='Área Responsable'
                    id='management_ids'
                    name='management_ids'
                    value={dataActivityTemplateItem?.management_ids || ''}
                    onSelect={handleAreaSelected}
                    requestApi={() => getManagementList()}
                    validation={validation}
                    isMulti
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`evidence_type_id${dataActivityTemplateItem?.evidence_type_id || ''}`}
                    label='Tipo de Evidencia'
                    id='evidence_type_id'
                    name='evidence_type_id'
                    value={dataActivityTemplateItem?.evidence_type_id || ''}
                    onSelect={handleEvidenceTypeSelected}
                    requestApi={() => getEvidenceTypeList()}
                    validation={validation}
                />
            </Col>
            <Col lg={3}>
                <OSelect
                    key={`supervisory_entity_ids${dataActivityTemplateItem?.supervisory_entity_ids || ''}`}
                    label='Entidad a Reportar'
                    id='supervisory_entity_ids'
                    name='supervisory_entity_ids'
                    value={dataActivityTemplateItem?.supervisory_entity_ids || ''}
                    onSelect={handleEntityReportSelected}
                    requestApi={() => getSupervisoryEntityList()}
                    validation={validation}
                    isMulti
                />
            </Col>
        </>
    );



    return (
        <React.Fragment>
            <Form
                className='tablelist-form'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                }}
            >
                <ModalBody className='modal-body'>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId='1'>
                            <Row className='g-3'>
                                {renderFormInputsInfo()}
                            </Row>
                        </TabPane>
                        <TabPane tabId='2'>
                            <Row className='g-3'>
                                {renderFormInputsControl()}
                            </Row>
                        </TabPane>
                    </TabContent>
                </ModalBody>
                <div className='modal-footer'>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button type='button' onClick={handleToggleModal} className='btn-danger btn-label'>
                            <i className="icon-x label-icon"></i> Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                            disabled={
                                isAddingObligation ||
                                isAddingActivityTemplateItem ||
                                isUpdatingObligation ||
                                isUpdatingActivityTemplateItem
                            }
                        >
                            {
                                isAddingObligation ||
                                    isAddingActivityTemplateItem ||
                                    isUpdatingObligation ||
                                    isUpdatingActivityTemplateItem
                                    ? (
                                        <i className="label-icon"><Spinner size='sm' /></i>
                                    )
                                    : <i className="ri-save-3-line label-icon"></i>
                            }
                            {isEdit ? 'Editar' : 'Crear'} Obligación
                        </button>
                    </div>
                </div>
            </Form>

            <FetchArticleModal
                isOpen={articleModal}
                handleClickFetchArticle={handleClickFetchArticle}
                onArticleSelected={handleArticleSelected}
            />

        </React.Fragment>
    );
};

export default ObligationForm;
